export const REQUEST_TYPES = [
  {
    id: 'peticion',
    icon: 'fa-file-circle-question',
    title: 'Petición',
    description:
      'Solicitud de información, orientación, consulta, gestión o reconocimiento de un derecho relacionado con los servicios de CAPSOS Telecomunicaciones.',
  },
  {
    id: 'queja',
    icon: 'fa-comment-dots',
    title: 'Queja',
    description:
      'Manifestación de inconformidad relacionada con la atención, actuación o comportamiento presentado durante la prestación del servicio.',
  },
  {
    id: 'reclamo',
    icon: 'fa-triangle-exclamation',
    title: 'Reclamo',
    description:
      'Solicitud de revisión o solución frente a una situación relacionada con la prestación, calidad, instalación, facturación o funcionamiento del servicio.',
  },
  {
    id: 'sugerencia',
    icon: 'fa-lightbulb',
    title: 'Sugerencia',
    description:
      'Propuesta orientada a mejorar los servicios, procesos, canales de atención o experiencia de los usuarios.',
  },
  {
    id: 'felicitacion',
    icon: 'fa-award',
    title: 'Felicitación',
    description:
      'Reconocimiento positivo relacionado con la atención recibida, el servicio prestado o la gestión realizada por la organización.',
  },
];
